class HeaderVaillantMenu {
  constructor() {
    this.headerWrapper = document.querySelector('.header-wrapper');
    this.stickyHeader = document.querySelector('sticky-header');
    this.menuItems = document.querySelectorAll('[data-vaillant-menu-item]');
    this.closeTimeout = null;

    if (!this.menuItems.length) return;

    this.setMenuTop();
    window.addEventListener('resize', this.setMenuTop.bind(this));
    window.addEventListener('scroll', this.setMenuTop.bind(this), { passive: true });
    window.addEventListener('vaillant:announcement-dismissed', this.setMenuTop.bind(this));

    this.menuItems.forEach((item) => {
      const panel = item.querySelector('[data-vaillant-menu-panel]');
      const trigger = item.querySelector('.header__menu-item');

      item.addEventListener('mouseenter', () => this.openMenu(item));
      item.addEventListener('mouseleave', (event) => {
        if (this.isMovingWithinMenu(event, item, panel)) return;
        this.scheduleClose();
      });

      panel?.addEventListener('mouseenter', () => this.cancelClose());
      panel?.addEventListener('mouseleave', (event) => {
        if (this.isMovingWithinMenu(event, item, panel)) return;
        this.scheduleClose();
      });

      trigger?.addEventListener('focus', () => this.openMenu(item));

      item.querySelectorAll('.header-vaillant-menu__primary-item').forEach((primaryItem) => {
        primaryItem.addEventListener('mouseenter', () => this.activatePrimary(item, primaryItem));
        primaryItem.addEventListener('focusin', () => this.activatePrimary(item, primaryItem));
      });
    });

    document.addEventListener('focusin', (event) => {
      if (!event.target.closest('[data-vaillant-menu-item]') && !event.target.closest('[data-vaillant-menu-panel]')) {
        this.closeAllMenus();
      }
    });
  }

  isMovingWithinMenu(event, item, panel) {
    const related = event.relatedTarget;
    if (!related) return false;
    return item.contains(related) || panel?.contains(related);
  }

  setMenuTop() {
    const headerSection = document.querySelector('.section-header');
    const bottom = headerSection ? Math.floor(headerSection.getBoundingClientRect().bottom) : 119;
    document.documentElement.style.setProperty('--vaillant-menu-top', `${bottom}px`);
  }

  openMenu(item) {
    this.cancelClose();
    this.closeAllMenus(item);

    item.classList.add('header-vaillant-menu__item--is-open');
    const panel = item.querySelector('[data-vaillant-menu-panel]');
    const trigger = item.querySelector('.header__menu-item');

    panel?.removeAttribute('hidden');
    trigger?.setAttribute('aria-expanded', 'true');
    if (this.headerWrapper) this.headerWrapper.preventHide = true;
    if (this.stickyHeader) this.stickyHeader.preventHide = true;
    this.headerWrapper?.classList.add('header-wrapper--menu-open');
    this.setMenuTop();
    this.clearPrimaryState(item);
  }

  clearPrimaryState(menuItem) {
    menuItem.querySelectorAll('.header-vaillant-menu__primary-item').forEach((item) => {
      item.classList.remove('is-active');
    });

    menuItem.querySelectorAll('.header-vaillant-menu__secondary-list').forEach((list) => {
      list.classList.remove('is-active');
    });
  }

  scheduleClose() {
    this.cancelClose();
    this.closeTimeout = window.setTimeout(() => this.closeAllMenus(), 250);
  }

  cancelClose() {
    if (this.closeTimeout) {
      window.clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }

  closeAllMenus(exceptItem = null) {
    this.menuItems.forEach((item) => {
      if (item === exceptItem) return;

      item.classList.remove('header-vaillant-menu__item--is-open');
      const panel = item.querySelector('[data-vaillant-menu-panel]');
      const trigger = item.querySelector('.header__menu-item');

      panel?.setAttribute('hidden', '');
      trigger?.setAttribute('aria-expanded', 'false');
    });

    if (!exceptItem) {
      if (this.headerWrapper) this.headerWrapper.preventHide = false;
      if (this.stickyHeader) this.stickyHeader.preventHide = false;
      this.headerWrapper?.classList.remove('header-wrapper--menu-open');
    }
  }

  activatePrimary(menuItem, primaryItem) {
    const index = primaryItem.dataset.primaryIndex;
    const hasChildren = primaryItem.classList.contains('header-vaillant-menu__primary-item--has-children');

    menuItem.querySelectorAll('.header-vaillant-menu__primary-item').forEach((item) => {
      item.classList.toggle('is-active', item === primaryItem);
    });

    menuItem.querySelectorAll('.header-vaillant-menu__secondary-list').forEach((list) => {
      list.classList.toggle('is-active', hasChildren && list.dataset.primaryIndex === index);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new HeaderVaillantMenu();
});
